var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMessage)?_c('div',{staticClass:"input-alert-new",class:{ left: _vm.left },on:{"click":_vm.hideMessage}},[_c('span',[_vm._v(_vm._s(_vm.message)+" "),(_vm.displayClose)?_c('i',{staticClass:"fa fa-times"}):_vm._e()]),_c('div')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }